import React from 'react';
import { cn } from '@express-labs/raven-tools';
import IconV2, { IconV2IconNames } from '../../../../IconV2/IconV2';
import s from './ProductShipping.scss';
type ProductShippingProps = {
  isStorePickup?: boolean;
};

type ShippingIconProps = {
  className?: string;
  icon: IconV2IconNames;
  label: string;
};

const ShippingIcon = ({ className, icon, label }: ShippingIconProps) => {
  return (
    <p className={s.shippingMethod}>
      <span>
        <IconV2 icon={icon} size="small" />
      </span>
      <span className={cn(s.shippingLabel, className)}>{label}</span>
    </p>
  );
};

const ProductShipping = ({ isStorePickup }: ProductShippingProps) => {
  if (isStorePickup === undefined) {
    return null;
  }

  if (isStorePickup === true) {
    return <ShippingIcon icon="store" label="Store Pickup" />;
  }

  return (
    <ShippingIcon
      className={s.shipToHomeLabel}
      icon="shipping-truck"
      label="Ship to Me"
    />
  );
};

export default ProductShipping;
